import { IReclassesAndAdjustmentExtension } from '@modeso/types__aumico-lib-annualreport-be';

export interface ICalculation extends IReclassesAndAdjustmentExtension {
    calculatedOpeningBalance: number;
    calculatedClosingBalance: number;
}
